import { Box, Header, addWithConfig } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';
import { primitive } from 'styles/constants';

export const ImageContainer = Box.withConfig({
  width: 'full',
  height: '216px',
  marginTop: '$16',
  overflow: 'hidden',
});

export const NotAvailableContainer = Box.withConfig({
  marginLeft: '$4',
  marginRight: '$4',
  color: primitive.$bbqBrown,
});

export const SectionTitle = Header.withConfig({
  marginTop: '$8',
  textAlign: 'center',
  marginBottom: '$6',
});

export const StyledActionButtonLink = addWithConfig(ActionButton).withConfig({
  style: { height: 48 },
});
